const firebaseConfig = {
    apiKey: "AIzaSyDLdmu-YhGkzDnAcYzOLVLCokSxInVe0vI",
    authDomain: "koi-jaiben.firebaseapp.com",
    projectId: "koi-jaiben",
    storageBucket: "koi-jaiben.appspot.com",
    messagingSenderId: "32331326101",
    appId: "1:32331326101:web:2fbeecde2dc312039e719c"
  };

  export default firebaseConfig;